export default "__VITE_IMAGE_ASSET__09787a66__";